import { render, staticRenderFns } from "./list-info.vue?vue&type=template&id=1d594702&scoped=true&"
import script from "./list-info.vue?vue&type=script&lang=js&"
export * from "./list-info.vue?vue&type=script&lang=js&"
import style0 from "./list-info.vue?vue&type=style&index=0&id=1d594702&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d594702",
  null
  
)

export default component.exports